(function () {
    let scrollBtn = document.querySelector('.scroll-to-top');

    if (typeof scrollBtn === 'undefined' || scrollBtn === null) {
        return;
    }
    window.onscroll = function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            scrollBtn.style.display = 'block';
        } else {
            scrollBtn.style.display = 'none';
        }
    };

    scrollBtn.addEventListener('click', function () {
        document.body.scrollIntoView({
            behavior: 'smooth',
        });
    });
})();
